"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureStrategy;

var _invariant = _interopRequireDefault(require("invariant"));

var _cond = _interopRequireDefault(require("lodash/cond"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _identity = _interopRequireDefault(require("lodash/identity"));

var _stubTrue = _interopRequireDefault(require("lodash/stubTrue"));

var _stubFalse = _interopRequireDefault(require("lodash/stubFalse"));

function ensureStrategy(strategyCandidate) {
  var strategy = (0, _cond.default)([[_isArray.default, _identity.default], [_isString.default, function (x) {
    return [x, []];
  }], [_stubTrue.default, _stubFalse.default]])(strategyCandidate);
  (0, _invariant.default)(strategy !== false, "Invalid strategy definition '".concat(strategyCandidate, "' found. Strategy definition have to be `tuple` or `string`."));
  return strategy;
}